import { isNull } from 'lodash'
import { ModalStore } from '../state/ModalStore'
import PurchaseStoreCreditModal from './Modals/PurchaseStoreCreditModal'

function PurchaseStoreCredit({ totalStoreCredits }) {
    const addModal = ModalStore((state) => state.add)

    const handlePurchaseModal = () => {
        addModal(
            <PurchaseStoreCreditModal totalStoreCredits={totalStoreCredits} />,
        )
    }

    if (isNull(totalStoreCredits)) return null

    return (
        <button
            onClick={handlePurchaseModal}
            className="md:block
            text-white text-sm font-medium p-1 px-3 rounded bg-olm-green">
            Purchase Store Credit
        </button>
    )
}

export default PurchaseStoreCredit
